// extracted by mini-css-extract-plugin
module.exports = {"app__header":"bm_fH","app__footer":"bm_Z","app__flex_row":"bm_fJ","app__content__list":"bm_fK"};